import React from 'react';
import { portfolioData } from '../../data/portfolioData';

export default function Marquee() {
  const items = portfolioData.marquee;
  // Duplicate the list so the -50% keyframe loops seamlessly.
  const loop = [...items, ...items];

  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee-track">
        {loop.map((item, i) => (
          <span className="marquee-item" key={i}>
            {item}
            <span className="star">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
